import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

export default function setupLocaleSwitches() {
    document.querySelectorAll('.locale-switch').forEach((element) => {
        if (!initializeOnce(element)) return;

        // Show updated toggle state immediately before page response
        element.addEventListener('click', () => {
            // Tell the turbo:frame-render handler not to scroll to the top of the reloaded frame
            document.getElementById(element.dataset.turboFrame)?.setAttribute('data-skip-scroll', '');

            element.classList.toggle('gray');
            const isChecked = element.getAttribute('aria-checked') === 'true';
            element.setAttribute('aria-checked', String(!isChecked));
            element.style.pointerEvents = 'none';

            // If the frame response never replaces the element (failed request), restore it
            setTimeout(() => {
                if (!element.isConnected) return;

                element.classList.toggle('gray');
                element.setAttribute('aria-checked', String(isChecked));
                element.style.pointerEvents = '';
            }, 5000);
        })
    });
}